import {
  CustomerAnalyticsListingFilterType,
  type PortfolioAnalyticsPropertyResponseDto,
} from '@zg-rentals/ts-customer-analytics-client';

const olympusAnalyticsListingTypes = [
  CustomerAnalyticsListingFilterType.TIER2_OVER_25,
  CustomerAnalyticsListingFilterType.TIER2_UNDER_25,
  CustomerAnalyticsListingFilterType.TIER3,
];

export const isClaimedProperty = (property: PortfolioAnalyticsPropertyResponseDto) => {
  return olympusAnalyticsListingTypes.includes(property.aggregateStats.analyticsListingType);
};
